/** @format */

import { createRoutingAction } from 'utils/routing';

export const GoToApiLandingPage = createRoutingAction('GO_TO_API_LANDING_PAGE');
